module.exports = __webpack_public_path__ + "img/SKMJ_sky3.2b3d33e7.png";